import {
    missingProductImageDarkUrl,
    missingProductImageUrl,
} from '../../common/components/molecules/ProductTeaser/ProductTeaser.consts';
import { useIsDarkMode } from './useIsDarkMode';

export const useMissingProductFallbackImage = () => {
    const isDarkMode = useIsDarkMode();
    const fallbackImageUrl = isDarkMode ? missingProductImageDarkUrl : missingProductImageUrl;
    return fallbackImageUrl;
};
